import { ANALYTICS_EVENT_NAMES } from "analytics/catalog/events";
import { buildCommonEventProps } from "analytics/core/commonProps";
import { trackEvent } from "analytics/core/tracker";

export type OnboardingAnalyticsContext = {
  pathname: string;
  search: string;
  businessId?: string | null;
  userId?: string | null;
  userEmail?: string | null;
  planType?: string | null;
  currency?: string | null;
};

const buildOnboardingProps = (
  context: OnboardingAnalyticsContext,
): Record<string, unknown> => {
  return buildCommonEventProps({
    screenKey: "welcome",
    pathname: context.pathname,
    search: context.search,
    businessId: context.businessId ?? null,
    userId: context.userId ?? null,
    userEmail: context.userEmail ?? null,
    planType: context.planType ?? null,
    currency: context.currency ?? null,
  });
};

export const trackWelcomePageViewed = (
  context: OnboardingAnalyticsContext,
): void => {
  trackEvent(ANALYTICS_EVENT_NAMES.welcomePageViewed, buildOnboardingProps(context));
};

export const trackWelcomeContinueClicked = (
  context: OnboardingAnalyticsContext,
): void => {
  trackEvent(
    ANALYTICS_EVENT_NAMES.welcomeContinueClicked,
    buildOnboardingProps(context),
  );
};

export const trackWelcomeLogoUploadClicked = (
  context: OnboardingAnalyticsContext,
): void => {
  trackEvent(
    ANALYTICS_EVENT_NAMES.welcomeLogoUploadClicked,
    buildOnboardingProps(context),
  );
};
